import { apiClient } from "./client";

// Reactivating an account its owner deleted. Signing in with the right
// password answers ACCOUNT_DELETED with a token; these two calls take it.

/** Emails a 6-digit code. Resolves to { sentTo, expiresInSeconds, resendAfterSeconds }. */
export async function sendReactivationCode(token) {
  const res = await apiClient.post("/auth/reactivation/send-code", { token });
  return res.data;
}

/** Resolves to a session, as signing in does: { accessToken, user }. */
export async function reactivateAccount(token, code) {
  const res = await apiClient.post("/auth/reactivation/verify", {
    token,
    code: code.trim(),
  });
  return res.data;
}
